import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import styles from "./table-actions.less"

class TableActions extends C {
  static displayName = "TableActions"

  static propTypes = {
    className: PropTypes.string,
  }

  render() {
    let className = classnames(styles.tableActions, this.props.className)

    return <div className={className}>{this.props.children}</div>
  }
}

export default TableActions
